import React, { useEffect } from 'react';
import UtilityBar from './UtilityBar';
import MainNav from './MainNav';
import Footer from './Footer';
import StickyCallBar from './StickyCallBar';
import { track, captureAttribution } from '@/lib/analytics';

const PageShell = ({ children, trackPage }) => {
  useEffect(() => {
    captureAttribution();
    window.scrollTo(0, 0);
    track('page_view', {}, trackPage);
  }, [trackPage]);

  return (
    <div className="amigos-app">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div className="film-grain" />
      <UtilityBar />
      <MainNav />
      <main id="main-content">{children}</main>
      <Footer />
      <StickyCallBar />
    </div>
  );
};

export default PageShell;
